import { atom } from "jotai";
import { Path } from "src/types";

export const mappedString = atom<string>("")
export const pathMap = atom<Path[]>([])